export default __webpack_public_path__ + "static/media/NotoSansKR-Light.e2557c2b.woff2";